export const programLogos = {
    1: "/images/programs_logo/ncd.png",
    2: "/images/programs_logo/sickle.png",
    4: "/images/programs_logo/nikshay.png",
    5: "/images/programs_logo/janani.png", // JANANI image
    6: "/images/programs_logo/uwin.png",
    8: "/images/programs_logo/pmndp.png",
    9: "/images/programs_logo/fbnc.png",
    10: "/images/programs_logo/afhc.png",
    11: "/images/programs_logo/rbsk.png", // RBSK image
    12: "/images/programs_logo/e-opd.png"
};

export const progremIDS = {
    NCD: 1,
    SICKLE: 2,
    NIKSHAY: 4,
    JANANI: 5,
    UWIN: 6,
    PMNDP: 8,
    FBNC: 9,
    AFHC: 10,
    RBSK: 11,
    EOPD: 12
}